import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import { show_import_ref_partstudio_modal } from '../state';
import import_partstudio_svg from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/reference_operation/import_partstudio.svg';
import { img } from '@phi/components';
import { IAuthentication } from '@phi/authentication/frontend';
import ImportPartstudioTooltip from '../tooltip';

export const ImportPartstudioIcon = import_partstudio_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },

        auth: { required: true, type: Object as PropType<IAuthentication> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Import PartStudio';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.auth.session_type.value.has('onshape')
                );
        },
    },

    methods: {
        onClick() {
            if (this.state.is_demo)
                this.auth.show_must_login_modal();
            else if (this.disabled)
                return;
            else
                show_import_ref_partstudio_modal();
        },
    },

    render() {
        return h(BarButton, {
            id: 'import-partstudio-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 13,
            help: 'import_partstudio_reference_model',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(import_partstudio_svg, this.alt),
            tooltip: ImportPartstudioTooltip,
        });
    },
});
